require('../../../modules/es.array.index-of');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').indexOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/index-of.js
// module id = 411
// module chunks = 0 1